export enum COMMANDS {
  OPENCUSTOMER = 'OpenCustomer',
  SETCUSTOMER = 'SetCustomer',
  SWITCHME = 'SwitchMe',
  OPENQUOTES = 'OpenQuotes',
}

//Messages we send
export type SearchCustomers = {
  command: 'executeSearch';
  data: {
    last_name: string;
    first_name?: string;
    zip?: string;
    state?: string;
  };
};
export type LoadCustomerMessage = {
  command: 'loadCustomer';
  data: {
    activeView?: string;
    customerId: string;
    customerIdType: string;
  };
};

export type SwitchMeMessage = {
  command: 'loadClaimsUI';
  data: {
    claimDetails: {
      claimNumbers?: string[];
      selectedClaim: string;
    };
    customerId: string;
  };
};

export type PolicyInfo = {
  effectiveDate: string;
  isLegacy: boolean;
  legacyUrl: string;
  lineOfBusiness: string;
  lineOfBusinessCode: string;
  policyNumber: string;
  statusCode: string;
};

export type BillingInfo = {
  billingId: string;
  dueDate: string;
  isLegacy: boolean;
  legacyUrl: string;
  lineOfBusiness: string;
  lineOfBusinessCode: string;
};

export type ClaimInfo = {
  claimNumber: string;
  claimStatus: string;
  isLegacyCVO: boolean;
  isSIUClaim: boolean;
  legacyUrl: string;
  lineOfBusiness: string;
  lineOfBusinessCode: string;
};
//Messages we receive
export type SetCustomerMessage = {
  customerId?: boolean | string;
  contactInfo: {
    name: {
      first: string;
      fullName: string;
      generationSuffix: string;
      last: string;
      middle: string;
    };
  };
  policyInfos?: PolicyInfo[];
  billingInfos?: BillingInfo[];
  claimInfos?: ClaimInfo[];
};

export type OpenQuoteMessage = {
  jurisdiction: string;
  umbrellaLineOfBusiness: boolean;
};
